module.exports = __webpack_public_path__ + "media/icons/print-checkbox-ad921855.svg";